/**
 * The country list shared by the public claim form, the "propose a monastery"
 * intake, and the admin / partner profile editors — so a country is picked the
 * same way everywhere rather than typed free-hand in one place and chosen from
 * a list in another.
 *
 * The six GOMPA is starting with sit at the top; the rest are the diaspora
 * hubs and the countries its monasteries are actually in, alphabetical.
 * "Other" is the escape hatch — staff can clarify anything unusual.
 */
export const PRIORITY_COUNTRIES = ['Nepal', 'India', 'Tibet', 'United States', 'Canada', 'Bhutan'];

export const OTHER_COUNTRIES = [
  'Australia', 'Austria', 'Bangladesh', 'Belgium', 'Brazil', 'China', 'Czech Republic',
  'Denmark', 'Finland', 'France', 'Germany', 'Hong Kong', 'Indonesia', 'Ireland', 'Israel',
  'Italy', 'Japan', 'Malaysia', 'Mexico', 'Mongolia', 'Myanmar', 'Netherlands',
  'New Zealand', 'Norway', 'Poland', 'Portugal', 'Russia', 'Singapore', 'South Korea',
  'Spain', 'Sri Lanka', 'Sweden', 'Switzerland', 'Taiwan', 'Thailand', 'Ukraine',
  'United Kingdom', 'Vietnam',
];

/** Every value the picker can hold, in display order — handy for validation
 * and for spotting a stored value the two groups don't cover. */
export const ALL_COUNTRIES = [...PRIORITY_COUNTRIES, ...OTHER_COUNTRIES, 'Other'];
